export const SUPPORTED_DOCUMENT_LANGUAGES = ["en", "es"];

export const resolveDocumentLanguage = (language) => {
  const baseLanguage = String(language || "")
    .trim()
    .toLowerCase()
    .split("-")[0];

  return SUPPORTED_DOCUMENT_LANGUAGES.includes(baseLanguage) ? baseLanguage : "en";
};

/**
 * Keep the HTML language in step with i18next.
 *
 * Besides helping assistive technology, this tells browser translation tools
 * that Spanish UI is already Spanish instead of inviting them to translate
 * catalog terms such as "Inter" and "Rib 30" a second time.
 */
export const syncDocumentLanguage = (
  language,
  documentElement = typeof document !== "undefined" ? document.documentElement : null
) => {
  if (!documentElement) {
    return;
  }

  documentElement.lang = resolveDocumentLanguage(language);
};
